import { faX } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStream, faTv, faLightbulb, faPlug, faGamepad, faGlasses, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faPlaystation, faXbox, faAmazon, faApple, faGoogle } from '@fortawesome/free-brands-svg-icons'

const BrandImages = {
  "Oculus": faGlasses,
  "Nintendo": faGamepad,
  'Sony': faPlaystation,
  'Microsoft': faXbox,
  'Google': faGoogle,
  'tv':faTv,
  'Roku': faStream,
  'Amazon': faAmazon,
  'Apple': faApple,
  'Merkury': faLightbulb,
  'Wemo': faLightbulb,
  'Lumiman': faLightbulb,
  'LuvLink': faLightbulb,
  'TP-Link': faPlug,
  'Gosund': faLightbulb,
  'Samsung': faPhone
} // used for brand icons

export default function MoreInfoBox({data, display, setDisplay}){ // used to pick status color
    let spanColor = '';
    switch (data["Status"]){
    case "Obsolete":
        spanColor = "gray";
        break;
    case "Verified":
        spanColor = "green";
        break;
    case "Supported by OIT":
        spanColor = "green";
        break;
    case "verified":
        spanColor = "green";
        break;
    case "Problems":
        spanColor = "orange";
        break;
    case "Xfinity compatible. Poor performance in tests.":
        spanColor = "orange";
        break;
    case "Issue with Compatibility (outdated wireless technology)":
        spanColor = "orange";
        break;
    case "Compatible (not recommended for live tv streaming)":
        spanColor = "orange";
        break;
    case "Issue with Compatibility (poor wireless connection)":
        spanColor = "orange";
        break;
    case "Potential compatibility issues (only 2.4GHz)":
        spanColor = "orange";
        break;
    case "Potential compatibility issues (outdated wireless technology)":
        spanColor = "orange";
        break;
    case "Potential compatibility issue: (poor wireless connection)":
        spanColor = "orange";
        break;
    case "Unverified":
        spanColor = "teal";
        break;
    case "Untested":
        spanColor = "teal";
        break;
    case "Not Allowed":
        spanColor = "red";
        break;
    default:
        spanColor = "red"
    }
  return (
    <div className="chargerDevices-deviceList-moreInfo-container" style={{display:display, zIndex:4}}>
      <div className="chargerDevices-deviceList-moreInfo-item">
        <span className="chargerDevices-deviceList-CloseWindow" onClick={()=>{setDisplay("none")}}><FontAwesomeIcon icon={faX}/></span>
        <span style={{position:'absolute', fontSize:'30px', top:'10px', right:'10px'}}>{BrandImages[data.Brand] ? <FontAwesomeIcon icon={BrandImages[data.Brand]}/> : <FontAwesomeIcon icon={BrandImages["tv"]}/> }</span>
        <h3>{data.Brand}</h3>
        <h4>Device Model: {data["Device Model/Series"]}</h4>
        <h4>Generation: {data["Generation"]}</h4>
        {data["Release Date (Mon-YY)"] && <h4>Release Date: {data["Release Date (Mon-YY)"]}</h4>}
        {data["Release Year"] && <h4>Release Year: {data["Release Year"]}</h4>}
        <h4>Wireless Gen: {data["Wireless Generation"]}</h4>
        <h4>Status: <span className='chargerDevices-deviceList-moreInfo-span' style={{backgroundColor: spanColor}}>{data["Status"]}</span></h4>
      </div>
    </div>
  ) // more info window, there are conditional styles and uses of conditional displays, like difference between release year and release date
}